export default class ProductConfiguratorValue {
    _configurator;
    _group;
    _selected = false;
    _entryValue = null;
    valueID = "";
    optionID = "";
    optionNumber = "";
    selectionGroup = "";
    scopes = [];
    caption = "";
    description = "";
    infoLink = "";
    disabled = false;
    possible = true;
    actAsRadio = false;
    isDefault = false;
    priceMode = 0;
    price = 0;
    priceFormated = "";
    entryField = null;
    options = [];
    get title() {
        return this.possible ? this.caption : "NICHT! - " + this.caption;
    }
    get entryValue() {
        return this._entryValue;
    }
    set entryValue(value) {
        //Set
        this._entryValue = value;
        //Summary
        if (this._configurator) {
            this._configurator.OnEntryValueChanged(this._group, this, value);
        }
    }
    get selected() {
        return this._selected;
    }
    set selected(value) {
        if (this._selected === value) {
            return;
        }
        var tOld = this._selected;
        this._selected = value;
        if (this._configurator) {
            this._configurator.OnValueChanged(this._group, this, tOld, value);
        }
    }
    constructor(Configurator, group, init) {
        //Data
        Object.assign(this, init);
        //Value
        this._configurator = Configurator;
        this._group = group;
    }
    setSelected(value) {
        this._selected = value;
    }
}
